<template>
    <el-input
        v-model="value"
        type="search"
        class="span_12 h-4"
        v-bind:id="elementName"
        @change="change"
        :placeholder="placeholder"
    />
</template>

<script>
import AddressFrenchDOMTOMAdapter from 'Services/Adapters/AddressFrenchDOMTOMAdapter.js';
import Feature from 'Services/Feature';

import JawgJSLoader from '@jawg/js-loader';
import Env from 'Services/Env';
import { mapState } from 'vuex';
import { formatAddressFromJawgs } from '../../helpers/addressHelpers';

export default {
    props: {
        defaultValue: {
            type: String,
            required: false,
            default: '',
        },
        placeType: {
            type: String,
            required: false,
            default: '',
        },
        elementName: {
            type: String,
            required: false,
            default: 'address-input',
        },
        templates: {
            type: [Object, Boolean],
            required: false,
            default: () => {
                return false;
            },
        },
        placeholder: {
            type: String,
            required: false,
            default: '',
        },
    },

    data() {
        return {
            value: '',
            suggestion: {},
            placesAutocomplete: null,
            element: null,
            addressAdapter: new AddressFrenchDOMTOMAdapter(),
            token: Env.get('jawg').token,
            loader: null,
            location: {
                latitude: 46.1620299,
                longitude: -1.246513,
            },
            jawgLoader: null,
        };
    },
    computed: {
        ...mapState('corp', {
            corpMainAddress: 'mainAddress',
        }),
    },
    methods: {
        setVal(val) {
            this.placesAutocomplete.setVal(val);
        },
        change(value) {
            //No autocomp
            if (value != this.suggestion.value) {
                this.$emit('bubble-address', { value, type: 'noAlgolia', id: this.elementName });
            }
        },
        failback() {
            this.placesAutocomplete.destroy();
            this.element.focus();
            this.$emit('algolia-disable', true);
        },
        buildOptionsJawgs() {
            return {
                input: `#${this.elementName}`,
                language: 'fr',
                searchOnTyping: true,
                layers: ['address', 'venue', 'locality'],
                focusPoint: {
                    lat: this.location.latitude,
                    lon: this.location.longitude,
                },
                onClick: (feature) => {
                    let address = formatAddressFromJawgs(feature);
                    this.addressAdapter.set(address).adapt();
                    this.$emit('bubble-address', address);
                },
                onError: () => this.failback(),
            };
        },
    },
    async mounted() {
        this.location.latitude = parseFloat(this.corpMainAddress?.lat) ?? this.location.latitude;
        this.location.longitude = parseFloat(this.corpMainAddress?.lng) ?? this.location.longitude;

        this.element = document.getElementById(this.elementName);
        this.value = this.defaultValue;
        this.element.value = this.defaultValue;
        if (!Feature.isEnabled('algolia')) {
            //algolia disabled
            this.$emit('algolia-disable', true);
            return;
        }
        let jawgPlaces = !window.JawgPlaces
            ? await this.jawgLoader.loadJawgPlaces()
            : await window.JawgPlaces;

        class FilteredInput extends jawgPlaces.Input {
            constructor(options) {
                super(options);
            }
            showResults(results) {
                let tempFeatures = [];
                for (let feature of results.features) {
                    let properties = feature.properties;
                    if (undefined === properties.postalcode || undefined === properties.locality) {
                        continue;
                    }
                    tempFeatures.push(feature);
                }
                results.features = tempFeatures;
                super.showResults(results);
            }
        }

        return new FilteredInput(this.buildOptionsJawgs());
    },
    created() {
        this.jawgLoader = new JawgJSLoader({ accessToken: this.token });
        EventBus.on('form:third:create:setAddressAlgolia', (payload) => {
            this.placesAutocomplete.setVal(payload);
        });
    },
    destroyed() {
        EventBus.off('form:third:create:setAddressAlgolia');
    },
};
</script>
